import { i18n } from "@tellescope/i18n";
import { getMedStatusTranslations } from "@tellescope/utils";

export const getVitalsClassificationTranslations: () => Record<string, string> = () => ({
  Target: i18n.t("Target", { ns: "vitals" }),
  High: i18n.t("High", { ns: "vitals" }),
  "Very High": i18n.t("Very High", { ns: "vitals" }),
  "Critical High": i18n.t("Critical High", { ns: "vitals" }),
  Low: i18n.t("Low", { ns: "vitals" }),
  "Very Low": i18n.t("Very Low", { ns: "vitals" }),
  "Critical Low": i18n.t("Critical Low", { ns: "vitals" }),
});

export const getReverseStatusTranslations: () => Record<string, string> = () =>
  Object.fromEntries(Object.entries(getMedStatusTranslations()).map(([key, value]) => [value, key]));
